module.exports = {
  apiUrl: process.env.REACT_APP_BASE_URL,
  getAllCountries: `${process.env.REACT_APP_COUNTRY_HOST}/rest/v2/all?fields=name;languages;callingCodes`,
};
